import { render, staticRenderFns } from "./promotion-and-top10-slow-sold.vue?vue&type=template&id=357ebe6f&scoped=true"
import script from "./promotion-and-top10-slow-sold.vue?vue&type=script&lang=js"
export * from "./promotion-and-top10-slow-sold.vue?vue&type=script&lang=js"
import style0 from "./promotion-and-top10-slow-sold.vue?vue&type=style&index=0&id=357ebe6f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "357ebe6f",
  null
  
)

export default component.exports